module.exports = __webpack_public_path__ + "img/20210906-1630898535603197.184b2cd8.jpg";